var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNameLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 292 243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        font-size: 100px;\n        font-family: LucidaSans, Lucida Sans;\n      }\n\n      .cls-2 {\n        fill: #5bc3eb;\n      }\n\n      .cls-3 {\n        filter: url(#V);\n      }\n\n      .cls-4 {\n        filter: url(#A-2);\n      }\n\n      .cls-5 {\n        filter: url(#R);\n      }\n\n      .cls-6 {\n        filter: url(#U);\n      }\n\n      .cls-7 {\n        filter: url(#A);\n      }\n\n      .cls-8 {\n        filter: url(#G);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "G",
    x: 0,
    y: 0,
    width: 89,
    height: 129,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "A",
    x: 105,
    y: 0,
    width: 85,
    height: 129,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "U",
    x: 207,
    y: 0,
    width: 85,
    height: 129,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "R",
    x: 8,
    y: 114,
    width: 79,
    height: 129,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "A-2",
    x: 105,
    y: 114,
    width: 85,
    height: 129,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "V",
    x: 208,
    y: 114,
    width: 81,
    height: 129,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "name_logo",
    transform: "translate(-96.5 -97.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8",
    transform: "matrix(1, 0, 0, 1, 96.5, 97.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "G-2",
    "data-name": "G",
    className: "cls-1",
    transform: "translate(39.5 95.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.133,
    y: 0
  }, "G"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7",
    transform: "matrix(1, 0, 0, 1, 96.5, 97.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "A-3",
    "data-name": "A",
    className: "cls-1",
    transform: "translate(142.5 95.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.497,
    y: 0
  }, "A"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-6",
    transform: "matrix(1, 0, 0, 1, 96.5, 97.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "U-2",
    "data-name": "U",
    className: "cls-2",
    transform: "translate(244.5 95.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.644,
    y: 0
  }, "U"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5",
    transform: "matrix(1, 0, 0, 1, 96.5, 97.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "R-2",
    "data-name": "R",
    className: "cls-1",
    transform: "translate(42.5 209.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.616,
    y: 0
  }, "R"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, 96.5, 97.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "A-4",
    "data-name": "A",
    className: "cls-1",
    transform: "translate(142.5 209.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.497,
    y: 0
  }, "A"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "matrix(1, 0, 0, 1, 96.5, 97.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "V-2",
    "data-name": "V",
    className: "cls-1",
    transform: "translate(243.5 209.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.69,
    y: 0
  }, "V"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameLogo);
export default __webpack_public_path__ + "static/media/name_logo.153b8da156d93b0272723581e64bff33.svg";
export { ForwardRef as ReactComponent };